import React from "react";
import "./Experience.css";
import BeehivveLogo from "../../images/beehivve-logo.png";
import { MdLocationOn } from "react-icons/md";
import { ImQuotesLeft } from "react-icons/im";
import MailIcon from "../../images/gmail-icon.png";
import { Link } from "react-router-dom";
import Title from "../Title/Title";

const Experience = () => {
  return (
    <div className="exp-container">
      <div className="mb-9"></div>
      <div className="back-btn">
        <Link to="/">
          <button className="backtohome">&#60; Back to Home</button>
        </Link>
      </div>
      <div className="mb-2"></div>
      <Title title="Experiences" />
      <div className="company-boxes">
        <div className="company-box">
          <img
            src="https://cdn.helloasso.com/img/photos/croppedimage-375538167f334e0998d11347fe6584ad.png"
            alt="beehivve-logo"
            className="exp-img"
          />
        </div>
        <div className="company-box">
          <span className="company-heading">
            <h2 className="exp-duration" style={{ color: "rgb(4, 87, 183)" }}>
              Lodgeme
            </h2>
          </span>
          <span className="head-location">
            <span>
              <MdLocationOn className="location-icon" />
            </span>
            <span className="exp-location">
              6, Rue d'armaille, Paris, Île-de-France 75017, France
            </span>
          </span>
          <span className="company-heading">
            <h2 className="exp-duration-month">
              From November 2022 - January 2024
            </h2>
          </span>
          <div className="company-heading">
            <a
              href="https://lodgeme.com"
              target="_blank"
              className="website-link"
              rel="noreferrer"
              style={{ color: " rgb(4, 87, 183)" }}
            >
              Visit Lodgeme Website
            </a>
          </div>
          <span className="company-heading">
            <h2 className="exp-duration-month">
              Worked with React js as frontend and Node js as backend/ PHP and
              Mysql
            </h2>
          </span>
          <p className="about-beehivve">
            Lodgeme is a client of Airbnb tour service which offers you to book
            properties such as houses,lodges,apartment for your travel purpose.
            The work was to create multiple websites and handle houses with
            appropriate databases for the manager to interact with the admin who
            posts there properties and even for the customers to book houses and
            handle payments. This was related to a microservices part where I
            need to work on all aspects of website that has to be handled.The
            main website was built using React js and MongoDB (MERN stack) to
            have friendly UI and easily accessible backend and for client
            advertisements and form related weblinks were done using PHP and
            MySql.
            <a
              href="https://lodgeme.com"
              target="_blank"
              className="beeanco"
              rel="noreferrer"
            >
              {" "}
              Lodgeme
            </a>
          </p>
          <div className="contact-box">
            <span
              className="company-heading"
              style={{
                textAlign: "center",
                fontSize: "20px",
                color: " rgb(4, 87, 183)",
              }}
            >
              Contact below for more details
              <a
                className="email"
                href="mailto:corentin.clamens@lodgeme.fr"
                target="_blank"
                rel="noreferrer"
              >
                Corentin Clamens, Founder of Lodgeme
              </a>
              <a
                href="mailto:corentin.clamens@lodgeme.fr"
                target="_blank"
                rel="noreferrer"
              >
                <img src={MailIcon} alt="mail-png" className="email-icon" />
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className="company-boxes">
        <div className="company-box">
          <img src={BeehivveLogo} alt="beehivve-logo" className="exp-img" />
        </div>
        <div className="company-box">
          <span className="company-heading">
            <h2 className="exp-duration" style={{ color: "rgb(4, 87, 183)" }}>
              Beehivve
            </h2>
          </span>
          <span className="head-location">
            <span>
              <MdLocationOn className="location-icon" />
            </span>
            <span className="exp-location">
              Tegetthoffstrasse 7/4 1010, Vienna, Austria
            </span>
          </span>
          <span className="company-heading">
            <h2 className="exp-duration-month">
              From January 2022 - September 2022
            </h2>
          </span>
          <div className="company-heading">
            <a
              href="https://beehivve.com"
              target="_blank"
              className="website-link"
              rel="noreferrer"
              style={{ color: " rgb(4, 87, 183)" }}
            >
              Visit Beehivve Website
            </a>
          </div>
          <span className="company-heading">
            <h2 className="exp-duration-month">
              Worked with React js as frontend and firebase as backend
            </h2>
          </span>
          <p className="about-beehivve">
            Beehivve works with sustainability criteria and quality management
            on beeanco, which is able to advise and support numerous companies
            in the direction of more sustainability. With the know-how we have
            already gained about sustainability and sustainable products, we
            will help our members to find suitable solutions to become more
            sustainable. Beehivve has gained several years of experience in the
            area of B2C and sustainability with our marketplace
            <a
              href="https://www.beeanco.com"
              target="_blank"
              className="beeanco"
              rel="noreferrer"
            >
              {" "}
              Beeanco
            </a>
          </p>
          <div className="contact-box">
            <span
              className="company-heading"
              style={{
                textAlign: "center",
                fontSize: "20px",
                color: " rgb(4, 87, 183)",
              }}
            >
              Contact below for more details
              <a
                className="email"
                href="mailto:hr@beehivve.com"
                target="_blank"
                rel="noreferrer"
              >
                Elisabeth Keck, Co-Founder, Events, Business Development
              </a>
              <a href="mailto:hr@beehivve.com" target="_blank" rel="noreferrer">
                <img src={MailIcon} alt="mail-png" className="email-icon" />
              </a>
            </span>
          </div>
        </div>
      </div>

      <div className="mb-5"></div>
      <div className="comment-box">
        <span>
          <ImQuotesLeft className="quote-icon" />
        </span>
        <span className="comment-text">
          Mr.Varun worked efficiently and effectively on projects as part if the
          web development teat, his work contributed greatly to the strategy to
          achieve the backend part worthy and user friendly for our team to
          access, Mr.Varun was a great addition to our team. As a developer he
          completed his work tasks conscientiously and independently and working
          together was excellent
        </span>
        <p className="founder"> - Christoph Widl, Co-Founder, Beehivve</p>
      </div>
      <div className="mb-5"></div>
    </div>
  );
};

export default Experience;
